<template>
  <div 
    v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
    ref="bienvenidaRef"
    class="bienvenida-overlay"
  >
    <div ref="contenidoRef" class="overlay-content">
      <!-- Franja superior con ornamento y texto -->
      <div class="franja-superior">
        <img ref="ornamentoArriba" src="@/assets/lineas.png" alt="ornamento" class="ornamento-arriba" />
<span ref="tituloRef" class="titulo-pase">
  <span class="letra-a">A</span>preciable
</span>      </div>
      
      <!-- Nombre del invitado -->
      <div ref="textoRef" class="welcome-text">
        {{ welcomeText }}
      </div>

      <!-- Mensaje de bienvenida -->
      <div ref="mensajeRef" class="mensaje-bienvenida">
        Para nosotros sería un honor contar con tu presencia en este día tan especial donde celebro mis XV.
        <br><br>
      </div>

      <!-- Info -->
      <div class="info-container">
        <div v-if="(paquete === 3 || paquete === 4) && numpase" ref="paseRef" class="info-item">
          <i class="fas fa-ticket-alt"></i>
          <span>PASES: {{ numpase }}</span>
        </div>
        <div v-if="paquete === 4 && mesaText" ref="mesaRef" class="info-item">
          <i class="fas fa-circle"></i>
          <span>MESA: {{ mesaText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, computed, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import axios from 'axios';
import baseUrl from '@/api';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'InvitadoEvento',
  props: {
    idInvitado: Number,
    nombre: String,
    idFestejado: Number
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const contenidoRef = ref(null);
    const tituloRef = ref(null);
    const textoRef = ref(null);
    const mensajeRef = ref(null);
    const paseRef = ref(null);
    const mesaRef = ref(null);
    const tooltipRef = ref(null);
    const ornamentoArriba = ref(null);
    const ornamentoAbajo = ref(null);

    const welcomeText = ref('');
    const mesaText = ref('');
    const numpase = ref(null);
    const paquete = ref(null);
    const showTooltip = ref(false);
    let tooltipTimeout;

    const isValidIdInvitado = computed(() => !isNaN(props.idInvitado) && props.idInvitado > 0);

    const fetchData = async () => {
      if (isValidIdInvitado.value) {
        try {
          const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${props.idInvitado}`;
          const response = await axios.get(url);
          welcomeText.value = response.data.nombre_mostrar;
          mesaText.value = response.data.num_mesa;
          numpase.value = response.data.num_pase;
          paquete.value = response.data.paquete;
        } catch (err) {
          console.error('Error al obtener los datos', err);
        }
      }
    };

    const animateElements = () => {
      const tl = gsap.timeline();

      tl.fromTo(ornamentoArriba.value, { rotation: 0 }, {
        rotation: 360,
        duration: 1,
        ease: 'power2.out'
      });

      tl.fromTo(tituloRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.5");
      tl.fromTo(textoRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");
      tl.fromTo(mensajeRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");
      tl.fromTo([paseRef.value, mesaRef.value], { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");

      tl.fromTo(ornamentoAbajo.value, { rotation: 0 }, {
        rotation: 360,
        duration: 1,
        ease: 'power2.out'
      }, "-=0.8");

      gsap.fromTo(
        tooltipRef.value,
        { opacity: 0, y: -15, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 1.5, ease: "elastic.out(1, 0.5)" }
      );
    };

    const resetElements = () => {
      gsap.set([tituloRef.value, textoRef.value, mensajeRef.value, paseRef.value, mesaRef.value], {
        opacity: 0,
        y: 30
      });
      gsap.set([ornamentoArriba.value, ornamentoAbajo.value], {
        rotation: 0
      });
      gsap.set(tooltipRef.value, { opacity: 0 });
    };

    onMounted(async () => {
      await fetchData();
      await nextTick();

      ScrollTrigger.create({
        trigger: bienvenidaRef.value,
        start: 'top 85%',
        onEnter: () => {
          showTooltip.value = true;
          animateElements();
        },
        onLeaveBack: () => {
          showTooltip.value = false;
          resetElements();
        }
      });
    });

    onBeforeUnmount(() => {
      clearTimeout(tooltipTimeout);
    });

    return {
      bienvenidaRef, contenidoRef, tituloRef, textoRef, mensajeRef,
      paseRef, mesaRef, tooltipRef, ornamentoArriba, ornamentoAbajo,
      welcomeText, mesaText, numpase, paquete, showTooltip
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;1,400&family=Poppins:wght@400;500;600&display=swap');

.bienvenida-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #4979a0;
  background: #f5f0e6; /* Transparente para adaptarse al fondo global */
  min-height: 40vh;
  perspective: 1000px;
  padding: 10px 10px;
  box-sizing: border-box;
}

.overlay-content {
  padding: 20px 20px;
  border-radius: 15px;
  text-align: center;
  width: 100%;
  max-width: 450px;
  transform-style: preserve-3d;
  transition: transform 0.3s ease;
  position: relative;
  background: transparent;
}

.franja-superior {
  position: relative;
  display: inline-block;
}

.titulo-pase {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 42px !important;
  color: #cba56b;
  display: block;
  margin-top: 10px;
  font-weight: 500;
}

.welcome-text {
  font-size: 1.8rem;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  color: #4979a0;
  margin: 10px 0 10px;
  letter-spacing: 1px;
}

.mensaje-bienvenida {
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  color: #4979a0;
  margin-top: 10px;
  line-height: 1.7;
}

.info-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
  margin-top: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  background-color: #cba56b;
  padding: 6px 16px;
  border-radius: 20px;
  letter-spacing: 1px;
  box-shadow: 0 3px 8px rgba(73, 121, 160, 0.15);
}

.info-item i {
  margin-right: 8px;
  font-size: 1rem;
  color: #ffffff;
}

.tooltip {
  position: absolute;
  bottom: 0px;
  background: #4979a0;
  color: white;
  padding: 4px 15px;
  border-radius: 8px;
  font-size: 13px;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ornamento-arriba,
.ornamento-abajo {
  position: absolute;
  width: 0%;
  height: auto;
  right: -50px;
  top: 0;
  transform: translateY(-20%);
  opacity: 0;
  z-index: 0;
  filter: brightness(0) saturate(100%) invert(48%) sepia(21%) saturate(986%) hue-rotate(167deg) brightness(92%) contrast(87%);
}
/* Importamos Pinyon Script junto con las demás fuentes */
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Pinyon+Script&display=swap');

.titulo-pase {
  font-family: 'Great Vibes', cursive, serif;
  /* tus demás estilos de título aquí... */
}

/* Aplica una 'A' mayúscula cursiva elegante de Pinyon Script */
.letra-a {
  font-family: 'Pinyon Script', cursive, serif !important;
  font-size: 1.15em; /* Un toque más grande para alinearse perfecto */
  display: inline-block;
}
</style>